export const EVENTS = {
  CLICK_SHOP_CTA: 'clickShopCTA - Hero',
  WATCH_VIDEO: 'watchVideo - Hero',
};

export const THEME = {
  FLEX: 'flex',
  PROMO: 'promo',
  BAU: 'bau',
};

export const THEME_VARIANT = {
  DEFAULT: 'default',
  EMPHASIZED: 'emphasized',
};

export const H_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};

export const V_ALIGN = {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom',
  STRETCH: 'stretch',
};

export const FONTS = {
  GEOGRAPH: 'Geograph',
  SELF_MODERN: 'Self Modern',
};
